import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CreditCard, Zap, ShieldCheck, Terminal, FileText, Globe, Menu, X } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { name: 'Generator', path: '/gen', icon: Zap },
    { name: 'Check Live', path: '/check-live', icon: ShieldCheck },
    { name: 'Check Stripe', path: '/check-stripe', icon: Terminal },
    { name: 'Articles', path: '/artigos', icon: FileText }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-lg border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-yellow-500 rounded-lg flex items-center justify-center">
              <CreditCard className="w-5 h-5 text-black" />
            </div>
            <span className="text-lg sm:text-xl font-bold">
              <span className="text-yellow-500">GENMOZ</span>
              <span className="text-white">PRO</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center space-x-2 px-3 lg:px-4 py-2 rounded-lg transition-colors ${
                    isActive
                      ? 'text-yellow-500 bg-yellow-500/10'
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="text-sm">{item.name}</span>
                </Link>
              );
            })}
          </nav>

          {/* Desktop Language Selector */}
          <div className="hidden md:flex items-center space-x-2 text-gray-400 hover:text-white cursor-pointer transition-colors">
            <Globe className="w-4 h-4" />
            <span className="text-sm">English</span>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-white p-2 hover:bg-white/5 rounded-lg transition-colors"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-t border-gray-800">
          <nav className="px-4 py-4 space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive
                      ? 'text-yellow-500 bg-yellow-500/10'
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span>{item.name}</span>
                </Link>
              );
            })}
            <div className="flex items-center space-x-3 px-4 py-3 text-gray-400 border-t border-gray-800 mt-2 pt-4">
              <Globe className="w-5 h-5" />
              <span>English</span>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
